<template>
  <g>
    <rect opacity="0.3" x="3" y="10" width="18" height="4" rx="2" />
    <rect x="7" y="10" width="10" height="4" rx="2" fill="currentColor" />
  </g>
</template>
